// Remember to update LanguageSelector as well.

export const supportedLanguages = [
  'en',
  'sv',
  'no',
  'dk',
  'de',
  'fr',
  'fi',
  'pt',
  'pl',
] as const;
export type Locale = (typeof supportedLanguages)[number];

export function isLocale(loc: string): loc is Locale {
  return supportedLanguages.find((l) => l === loc) !== undefined;
}
